import React from 'react';
import pt from 'prop-types';

import FeatureGate from 'app/launch-darkly/gates/feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

const TcfEnabledRow = ({ tcfEnabled }) => {
  return (
    <FeatureGate flagName={FEATURE_FLAGS.ecmIabTcfConsent}>
      <tr>
        <td>IAB TCF Consent</td>
        <td>{tcfEnabled.toString()}</td>
      </tr>
    </FeatureGate>
  );
};

TcfEnabledRow.propTypes = {
  tcfEnabled: pt.bool,
};
export default TcfEnabledRow;
